<footer>
  <app-partners></app-partners>
  <div class="bg-primary">
    <div class="px-4 py-16 flex flex-col items-center gap-8 border-b-2 border-black">
      <img src="assets/images/icon.svg" class="h-16" alt="Bongo's Bingo" />

      <div
        class="flex flex-col md:flex-row items-center gap-8 lg:gap-14 [&>a]:text-2xl [&>a]:font-bold [&>a]:text-white [&>a]:uppercase">
        <a [routerLink]="['/', 'events']" title="Search for an event">Events</a>
        @for(item of navigation(); track $index) {
        <a [routerLink]="navRoute(item.slug)" [title]="item.title">{{ item.short_title || item.title }}</a>
        }
        <a href="https://bespoke.bongosbingo.co.uk/" target="_blank" rel="noopener noreferrer" title="Bespoke">Bespoke</a>
      </div>
    </div>

    <div class="px-4 pt-2 pb-8 border-b-2 border-black">
      <app-newsletter></app-newsletter>
    </div>

    <div class="px-4 py-16 relative overflow-hidden">
      <img
        class="absolute w-52 top-[-1.5rem] right-[70vw] md:right-[80vw] lg:right-[75vw] 2xl:right-[70vw] xl:top-auto z-0"
        src="assets/images/unicorn.svg" alt="" />
      <img class="absolute w-52 top-72 left-[60vw] md:left-[80vw] lg:left-[75vw] 2xl:left-[70vw] xl:top-auto z-0"
        src="assets/images/duck.svg" alt="Duck" />

      <div class="flex flex-col items-center">
        <div id="app-banner" class="w-full max-w-3xl hidden xl:block z-10">
          <p class="text-3xl text-white font-normal max-w-md mx-auto my-4 text-center">
            Scan to download the app on Google Play or Apple App Store
          </p>

          <div class="lg:flex xl:flex-row xl:gap-8 justify-center w-full max-w-3xl hidden md:block z-10">
            <div class="qr-code-box p-12">
              <a href="" target="_blank" class="flex flex-col items-center gap-4">
                <div class="h-44 w-44 bg-white">
                  <img src="assets/images/qr-code-playstore.png"
                    alt="A QR code you can scan to download the Bongo Bingos app on the Google Play Store" />
                </div>
                <div class="flex justify-center">
                  <img class="w-10 h-10" src="assets/images/logo-playstore.png" alt="Google Play" />
                </div>
              </a>
            </div>

            <div class="qr-code-box p-12">
              <a href="" target="_blank" class="flex flex-col items-center gap-4">
                <div class="h-44 w-44 bg-white">
                  <img src="assets/images/qr-code-appstore.png"
                    alt="A QR code you can scan to download the Bongo Bingos app on the App Store" />
                </div>
                <div class="flex justify-center">
                  <img class="w-10 h-10" src="assets/images/logo-appstore.png" alt="App Store" />
                </div>
              </a>
            </div>
          </div>
        </div>

        <div id="app-links" class="xl:hidden flex flex-col gap-4 py-8">
          <h2 class="text-3xl font-black text-center text-white">Download Our App</h2>

          <a href="https://play.google.com/store/apps/details?id=uk.co.bongosbingo" target="_blank">
            <img src="assets/images/googleplay.svg" alt="Google Play Store" />
          </a>
          <a href="https://apps.apple.com/gb/app/bongos-bingo/id1471530672" target="_blank">
            <img src="assets/images/appstore.svg" alt="App Store" />
          </a>
        </div>

        <div class="flex flex-col items-center mt-[6rem] lg:mt-[11rem] xl:mt-0 xl:mb-10">
          <div class="flex xl:flex-row flex-col items-center xl:items-end gap-6 xl:gap-14 mt-20 lg:mt-10 mb-10">
            <a href="https://www.gambleaware.org/" target="_blank">
              <img src="assets/images/be-gamble-aware.svg" alt="Gamble Aware" class="max-w-[200px] max-h-[26px]" />
            </a>
            <a href="https://www.drinkaware.co.uk/" target="_blank">
              <img src="assets/images/be-drink-aware.svg" alt="Drink Aware" class="max-w-[200px] max-h-[26px]" />
            </a>
            <a href="https://www.gamblingcommission.gov.uk/" target="_blank">
              <img src="assets/images/gambling-commission.svg" alt="Gambling Commission" class="max-w-[200px] max-h-[26px]" />
            </a>
          </div>

          <nav
            class="flex flex-col xl:flex-row flex-wrap items-center justify-center gap-14 lg:gap-8 xl:gap-12 [&>a]:font-normal [&>a]:text-xl [&>a]:text-white [&>a]:text-center mb-8">
            <a [routerLink]="['/pages/how-to-play']">How to Play</a>
            <a [routerLink]="['/pages/terms-and-conditions']">Terms & Conditions</a>
            <a [routerLink]="['/pages/privacy-policy']">Privacy Policy</a>
            <a [routerLink]="['/pages/responsible-play']">Responsible Play</a>
            <a [routerLink]="['/pages/self-exclusion']">Self Exclusion</a>
            <a [routerLink]="['/locations']">Locations</a>
          </nav>

          <p class="text-white text-center">
            Copyright &copy; 2015 - {{ today | date:'yyyy' }} Shua Ltd trading as Bongo's Bingo | Company Number:
            09858266 | VAT Number: GB 248 494 370
            <br />
            <a class="hover:underline"
              href="https://www.gamblingcommission.gov.uk/public-register/business/detail/47699" target="_blank"
              rel="noopener noreferrer">Regulated by the Gambling Commission, Operating Licence Number
              047699-N-326687</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</footer>
